
import React, { useEffect, useRef, useState } from "react";
import {
    UserRound,
    Package,
    MessageCircle,
    ChevronLeft,
} from "lucide-react";

import "./UserMiniPanel.css";

import { Link } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

export default function UserMiniPanel({
    user,
    isAuthenticated,
    onLoginClick,
    loading = false,
}) {
    const { user: authUser, logout } = useAuth();

    const [open, setOpen] = useState(false);
    const userMiniRef = useRef(null);

    const displayName =
        `${user?.name || ""} ${user?.lname || ""}`.trim() ||
        "کاربر";

    const mobile = user?.mobile || "—";

    const avatar =
        user?.avatar ||
        user?.image ||
        user?.profile_image ||
        null;

    const closePanel = () => {
        setOpen(false);
    };

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!open) return;

            // Outside-click behavior is only needed on mobile.
            if (window.innerWidth > 640) return;

            if (
                userMiniRef.current &&
                !userMiniRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        };

        document.addEventListener("pointerdown", handleOutsideClick);

        return () => {
            document.removeEventListener("pointerdown", handleOutsideClick);
        };
    }, [open]);

    if (loading) {
        return (
            <div className="home-header__user-wrapper">
                <button
                    type="button"
                    className="home-header__action"
                    aria-label="حساب کاربری"
                >
                    <UserRound size={19} />
                </button>
            </div>
        );
    }

    /*
     * USER NOT LOGGED IN
     */
    if (!isAuthenticated) {
        return (
            <div className="home-header__user-wrapper">
                <button
                    type="button"
                    className="home-header__action"
                    aria-label="ورود"
                    onClick={() => {
                        if (onLoginClick) {
                            onLoginClick();
                        }
                    }}
                >
                    <UserRound size={19} />
                </button>
            </div>
        );
    }

    return (
        <div
            ref={userMiniRef}
            className={`user-mini ${open ? "user-mini--open" : ""}`}
            onMouseEnter={() => {
                if (window.innerWidth > 640) {
                    setOpen(true);
                }
            }}
            onMouseLeave={() => {
                if (window.innerWidth > 640) {
                    setOpen(false);
                }
            }}
        >
            {/* Trigger */}
            <button
                type="button"
                className="home-header__action user-mini__trigger"
                aria-label="حساب کاربری"
                aria-expanded={open}
                onClick={() => setOpen((value) => !value)}
            >
                <UserRound size={19} />
            </button>

            {open && (
                <div
                    className="user-mini__panel"
                    onMouseEnter={() => setOpen(true)}
                >

                    {/* User Header */}
                    <div className="user-mini__header">

                        <div className="user-mini__avatar">
                            {avatar ? (
                                <img
                                    src={avatar}
                                    alt={displayName}
                                />
                            ) : (
                                <UserRound size={28} />
                            )}
                        </div>

                        <div className="user-mini__identity">
                            <strong>{displayName}</strong>
                            <span>{mobile}</span>
                        </div>

                    </div>


                    <div className="user-mini__divider" />


                    {/* Navigation */}
                    <nav className="user-mini__links">

                        <Link
                            to="/dashboard/profile"
                            className="user-mini__link"
                            onClick={closePanel}
                        >
                            <span className="user-mini__link-icon">
                                <UserRound size={20} />
                            </span>

                            <span>پروفایل</span>

                            <ChevronLeft size={20} />
                        </Link>


                        <Link
                            to="/dashboard/orders"
                            className="user-mini__link"
                            onClick={closePanel}
                        >
                            <span className="user-mini__link-icon">
                                <Package size={20} />
                            </span>

                            <span>سفارش‌های من</span>

                            <ChevronLeft size={20} />
                        </Link>


                        <Link
                            to="/dashboard/comments"
                            className="user-mini__link"
                            onClick={closePanel}
                        >
                            <span className="user-mini__link-icon">
                                <MessageCircle size={20} />
                            </span>

                            <span>نظرات من</span>

                            <ChevronLeft size={20} />
                        </Link>

                    </nav>


                    <div className="user-mini__divider" />


                    {/* Logout */}
                    <div className="user-mini__logout">

                        <button
                            type="button"
                            className="user-mini__logout-button"
                            onClick={async () => {
                                closePanel();
                                await logout();
                            }}
                        >
                            خروج از حساب کاربری
                        </button>

                    </div>

                </div>
            )}
        </div>
    );
}